import { Platform } from 'react-native';

/** Dónde encontrar Caja en la navegación (no está bajo Perfil). */
export const cashManagementNavHint =
  Platform.OS === 'web' ? 'Caja en el menú lateral' : 'Más → Caja';
